import { useContext } from 'react';
import { ContactSidebarContext } from 'features/ContactSidebar/ContactSidebarContext';
import { compensationToFullText } from 'util/job/compensation';

export const ExpectedCompensation = () => {
  const { userProfile, hasPreferences } = useContext(ContactSidebarContext);

  if (!hasPreferences.expectedCompensation) {
    return null;
  }

  const expectedCompensation = userProfile?.expectedCompensation();

  return (
    <div className="space-y-1.5">
      <p className="text-primary-pure-blue">Expected Compensation:</p>
      <p>{compensationToFullText(expectedCompensation)}</p>
    </div>
  );
};

ExpectedCompensation.displayName = 'ExpectedCompensation';
